/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import PowerByAirwallex from '@/assets/svgs/powerByAirwallex.svg';
import BREAK_POINTS from '@/components/common/breakpoints';

type Props = {
  logoUrl?: string;
};

export const Index: React.FC<Props> = ({ logoUrl, ...rest }) => {
  return (
    <footer
      {...rest}
      css={css`
        padding-top: 114px;
        width: 500px;
        margin: 0 auto 32px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: bottom;
        column-gap: 8px;
        @media (max-width: ${BREAK_POINTS.mobile}px) {
          position: fixed;
          bottom: 0;
          margin-bottom: 0;
          padding-top: 48px;
          padding-bottom: 24px;
          width: 100%;
          flex-direction: column;
          align-items: center;
          row-gap: 8px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 18.08%);
        }
      `}
    >
      <PowerByAirwallex />
    </footer>
  );
};

export default Index;
